// @flow
import { Icon, Text, View } from 'reshaped';

import { Badge } from '@gandi/reshaped';
import { useTranslator } from '@gandi/translate';
import type { TranslatorProps } from '@gandi/translate';

import Sectigo from 'src/Svg/sectigo';

import style from './Offer.module.css';

type Provider = 'sectigo' | 'digicert';
type CertType = 'dv' | 'ov';

type Props = {
  label: string,
  provider: Provider,
  type: CertType,
  children: string,
};

const LOGO_BY_PROVIDER: { [Provider]: React.ElementType | null } = {
  sectigo: Sectigo,
  digicert: null, // TODO
};

const getBadgeLabel = (__: TranslatorProps['__']) => {
  return {
    dv: __('Standard'),
    ov: __('Pro'),
  };
};

export function Offer({ label, children, type, provider }: Props): React.Node {
  const { __ } = useTranslator();
  const ProviderLogo = LOGO_BY_PROVIDER[provider];
  const badgeLabel = getBadgeLabel(__)[type];

  return (
    <View padding={6} gap={2}>
      <Icon svg={ProviderLogo} size={5} className={style.icon} />
      <View direction="row" paddingBlock={1} gap={3}>
        <Text color="neutral-faded" variant="body-2" weight="medium">
          {label}
        </Text>
        {badgeLabel && <Badge color="informative">{badgeLabel}</Badge>}
      </View>
      <Text color="neutral-faded" variant="body-3" weight="regular">
        {children}
      </Text>
    </View>
  );
}
